module.exports = __webpack_public_path__ + "img/matt-sksm.c0bcc0e1.png";